import { Analytics } from '../modules/analytics';

import { WIDGET_NAME } from '@sitegen/common/constants';

const configureWidget = async (widget: WIDGET_NAME): Promise<void> => {
    Analytics.configure(widget);
};

export default configureWidget;
